var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconDecisions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.988,
    height: 11.84,
    viewBox: "0 0 15.988 11.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Icon_Decisions",
    transform: "translate(8598.203 13700)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_like_888708_000000",
    transform: "translate(-8598.203 -13700)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36204",
    "data-name": "Path 36204",
    d: "M43.259,20.2a.648.648,0,0,0-.654-.654H40.641c-.1,0-.471-.157-.183-.6a6.046,6.046,0,0,0,.183-1.623.655.655,0,0,0-1.309,0A2.69,2.69,0,0,1,37.5,19.809v3.4c.838.288,1.047.785,2.094.785h1.963a.654.654,0,0,0,.523-1.047.648.648,0,0,0,.654-.654.713.713,0,0,0-.157-.445.645.645,0,0,0,.419-.6.713.713,0,0,0-.157-.445.63.63,0,0,0,.419-.6Z",
    transform: "translate(-34.883 -16.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36205",
    "data-name": "Path 36205",
    d: "M17.977,37.5H16.668v4.45h1.309a.788.788,0,0,0,.785-.785v-2.88a.771.771,0,0,0-.785-.785Z",
    transform: "translate(-16.668 -34.882)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "np_like_888708_000000-2",
    "data-name": "np_like_888708_000000",
    transform: "translate(-8590.592 -13695.489)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36206",
    "data-name": "Path 36206",
    d: "M37.5,20.463a.648.648,0,0,0,.654.654h1.963c.1,0,.471.157.183.6a6.046,6.046,0,0,0-.183,1.623.655.655,0,0,0,1.309,0,2.69,2.69,0,0,1,1.832-2.487v-3.4c-.838-.288-1.047-.785-2.094-.785H39.2a.654.654,0,0,0-.523,1.047.648.648,0,0,0-.654.654.713.713,0,0,0,.157.445.645.645,0,0,0-.419.6.713.713,0,0,0,.157.445.63.63,0,0,0-.419.6Z",
    transform: "translate(-37.5 -16.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36207",
    "data-name": "Path 36207",
    d: "M17.454,41.95h1.309V37.5H17.453a.788.788,0,0,0-.785.785v2.88a.771.771,0,0,0,.785.785Z",
    transform: "translate(-10.386 -37.238)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconDecisions);
export default __webpack_public_path__ + "static/media/Menu_Icon_Decisions.28899d29.svg";
export { ForwardRef as ReactComponent };